module.exports = __webpack_public_path__ + "static/img/bg-4.5002392a.png";